// extracted by mini-css-extract-plugin
export var bodyRow = "_em-d";
export var cardColumns = "_em-e";
export var ellipsesOverflow = "_em-2";
export var flatBottomCorners = "_em-3";
export var flatTopCorners = "_em-4";
export var headerActionsDropdown = "_em-f";
export var headerBottomRow = "_em-c";
export var headerTopRow = "_em-b";
export var orderDetailsWrapper = "_em-0";
export var orderInfoContainer = "_em-1";
export var productDetails = "_em-9";
export var productImage = "_em-5";
export var responsiveTable = "_em-8";
export var shipmentContainer = "_em-a";
export var tableBottomLeft = "_em-6";
export var tableBottomRight = "_em-7";
export var trackingLink = "_em-g";